import { XCircle } from '@phosphor-icons/react';

export default function ExpiredPage() {
  return (
    <div className="max-w-[700px] mx-auto px-4 py-16 text-center">
      <div className="flex items-center justify-center mb-3">
        <XCircle size={36} weight="duotone" className="text-brand-error" />
      </div>
      <h1 className="text-2xl font-semibold mb-2">Link expirat</h1>
      <p className="text-gray-700 mb-6">Acest link nu mai este disponibil. Te rugăm să soliciți un link nou.</p>
      {/* <p className="text-sm text-gray-500">Dacă ai întrebări, ne poți contacta oricând.</p> */}
    </div>
  );
}


